import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '@/lib/firebase';

export interface AuditLogEntry {
  action: string;
  entityType: string;
  entityId: string;
  churchId: string | null;
  userId: string;
  userName: string;
  details?: Record<string, unknown>;
}

export async function logAction(entry: AuditLogEntry): Promise<void> {
  await addDoc(collection(db, 'audit_logs'), {
    ...entry,
    timestamp: serverTimestamp(),
  });
}
